/**
 * NotesSection — private agent notes for the active lead.
 *
 * Iter 152.4 (Feb 2026, Yash) — extracted from ChatsPage.jsx Info tab to
 * keep that file moving toward a sensible size. Pure presentational; the
 * parent owns notes state + persistence.
 */
const NotesSection = ({
  notes,
  newNote,
  setNewNote,
  onAdd,
  onDelete,
  currentUserId,
}) => (
  <div className="px-4 py-3 border-t border-[--border]" data-testid="notes-section">
    <p className="text-[10px] font-bold text-[--text-muted] uppercase tracking-wider mb-2">Notes</p>
    <div className="flex gap-2 mb-2">
      <textarea
        value={newNote}
        onChange={(e) => setNewNote(e.target.value)}
        placeholder="Add a private note..."
        rows={2}
        className="flex-1 border-2 border-[--border] rounded-xl px-3 py-2 text-xs outline-none focus:border-[--accent-soft] resize-none"
        data-testid="note-input"
      />
      <button
        onClick={onAdd}
        disabled={!newNote.trim()}
        className="btn-primary text-xs px-3 h-fit mt-auto"
        data-testid="add-note-btn"
      >
        Add
      </button>
    </div>
    {notes.length === 0 ? (
      <p className="text-[10px] text-[--text-muted] text-center py-2">No notes yet</p>
    ) : (
      <div className="space-y-1.5 max-h-[240px] overflow-y-auto">
        {notes.map((n) => (
          <div
            key={n.id}
            className="bg-amber-50 border border-amber-200 rounded-lg p-2"
            data-testid={`note-${n.id}`}
          >
            <p className="text-[11px] text-[--text-primary] whitespace-pre-wrap">{n.content}</p>
            <div className="flex items-center justify-between mt-1">
              <p className="text-[9px] text-amber-600 font-bold">
                {n.author_name} · {new Date(n.created_at).toLocaleDateString()}
              </p>
              {n.author_id === currentUserId && (
                <button
                  onClick={() => onDelete(n.id)}
                  className="text-[9px] text-red-400 hover:text-red-600"
                  data-testid={`delete-note-${n.id}`}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default NotesSection;
